import { InternalButton } from "@sharedComponents/buttons";

import {
  isCollectionTypeProduct,
  isMedleyProduct,
  isThemedBoxProduct,
} from "@helpers/products/types";

import usePopulateItems from "@hooks/cart/use-populate-items";

import styles from "./main.module.scss";

const emptyArr = [];

const UpdateExistingCartItemPreferencesBtn = ({
  lineItem,
  restrictions,
  preferences = "",
  onSuccessCallback = () => {},
  btnParentClass = styles["bagBtnBlock"],
  btnClass = "",
  isDisabled = false,
}) => {
  const {
    id,
    intent,
    price,
    quantity,
    zoneId,
    itemType,
    orderProductSetRestrictions = emptyArr,
  } = lineItem;

  const { updateCollectionItemInCart, loading } = usePopulateItems();

  const disabled = loading || !quantity || isDisabled;

  const updateProduct = () => {
    const payload = {
      orderProductSetId: id,
      quantity: quantity,
      price: price,
      orderProductSetRestrictionId: orderProductSetRestrictions
        .map((restriction) => restriction.id)
        .join(","),
      intent,
      dietaryPreference: preferences,
      showToast: false,
      zoneId: zoneId,
      itemType: itemType,
    };
    if (isMedleyProduct(intent) && restrictions) {
      payload.restrictions = restrictions.map((r) => r.id || r).join(",");
      payload.isRestrictionsSelected = true;
    }
    if (isThemedBoxProduct(intent)) {
      payload.dietaryRestrictions = restrictions?.map((r) => r.id || r);
    }
    if (isCollectionTypeProduct(intent))
      return updateCollectionItemInCart(payload).then(() => onSuccessCallback());
  };

  return (
    <div className={btnParentClass}>
      <InternalButton
        text=""
        className={`${styles.addToBagBtn} ${btnClass}`}
        onClick={updateProduct}
        isLoading={loading}
        disabled={disabled}
      >
        Update Bag
      </InternalButton>
    </div>
  );
};

export default UpdateExistingCartItemPreferencesBtn;
